import type { ReactElement, ReactNode } from 'react';
import * as S from './IconWithTextCell.style';
import EllipsisTooltipTableCell from '../../EllipsisTooltipTableCell/EllipsisTooltipTableCell';

interface IconWithTextCellProps {
  iconComponent: ReactElement;
  children: ReactNode;
  tooltipTextContent: string;
}

const IconWithTextCell = ({
  children,
  iconComponent,
  tooltipTextContent
}: IconWithTextCellProps) => {
  return (
    <S.CellWrapper>
      {iconComponent}
      <S.EllipseIconWrapper>
        <EllipsisTooltipTableCell tooltipContent={tooltipTextContent}>
          {children}
        </EllipsisTooltipTableCell>
      </S.EllipseIconWrapper>
    </S.CellWrapper>
  );
};

export default IconWithTextCell;
